import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Avatar, AvatarFallback } from '../../../components/ui/avatar';
import { DropdownMenu, DropdownMenuItem, DropdownMenuSeparator } from '../../../components/ui/dropdown-menu';
import { useAuth } from '../../../contexts/AuthContext';
import { Profile, Logout, Setting2 } from 'iconsax-react';

const ProfileSection = () => {
  const navigate = useNavigate();
  const { user, tenant, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleViewProfile = () => {
    navigate('/profile');
    setOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="relative" ref={anchorRef}>
      <Button
        variant="ghost"
        className="flex items-center gap-2 px-2"
        onClick={handleToggle}
      >
        <Avatar className="h-8 w-8">
          <AvatarFallback className="bg-blue-500 text-white text-sm font-medium">
            {user?.name?.charAt(0) || 'U'}
          </AvatarFallback>
        </Avatar>
        <span className="text-sm font-medium capitalize">
          {user?.name || 'User'}
        </span>
      </Button>

      <DropdownMenu open={open} onClose={handleClose} anchorEl={anchorRef.current}>
        <div className="px-3 py-2">
          <p className="text-sm font-semibold">{user?.firstName} {user?.lastName}</p>
          <p className="text-xs text-muted-foreground">{user?.role}</p>
          <p className="text-xs text-muted-foreground">{tenant?.name}</p>
        </div>
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem onClick={handleViewProfile}>
          <Profile size={16} className="mr-2" />
          <span>View Profile</span>
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={handleClose}>
          <Setting2 size={16} className="mr-2" />
          <span>Account Settings</span>
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem onClick={handleLogout}>
          <Logout size={16} className="mr-2" />
          <span>Logout</span>
        </DropdownMenuItem>
      </DropdownMenu>
    </div>
  );
};

export default ProfileSection;